import React, { useEffect, useRef } from 'react';

const MatrixRain = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    // Установка размеров (теперь будет брать размер родителя - сетки)
    const resize = () => {
      if (canvas.parentElement) {
        canvas.width = canvas.parentElement.clientWidth;
        canvas.height = canvas.parentElement.clientHeight;
      }
    };
    resize();
    // Observer надежнее window.resize для элементов внутри DOM
    const resizeObserver = new ResizeObserver(() => resize());
    resizeObserver.observe(canvas.parentElement);

    // Конфигурация
    const fontSize = 13;
    const columns = Math.floor(canvas.width / fontSize);
    const drops = Array(columns).fill(1);

    const chars = '01XYZEFK0101WTF01ﾊﾐﾋｰｳｼﾅﾓﾆｻﾜﾂｵﾘｱﾎﾃﾏｹﾒｴｶｷﾑﾕﾗｾﾈｽﾀﾇﾍ';

    const draw = () => {
      // След стал прозрачнее, чтобы символы дольше оставались
      ctx.fillStyle = 'rgba(1, 4, 9, 0.15)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < drops.length; i++) {
        const text = chars[Math.floor(Math.random() * chars.length)];

        // Яркость значительно повышена
        // Основной цвет - ярко-зеленый, иногда белый для "блеска"
        const isWhite = Math.random() > 0.95;
        ctx.fillStyle = isWhite ? '#fff' : '#0f0';

        // Повышаем яркость самих букв (меньше прозрачности)
        // Но при этом общий слой canvas будет полупрозрачным
        if (!isWhite) {
            ctx.globalAlpha = Math.random() * 0.5 + 0.5; // От 0.5 до 1.0
        } else {
            ctx.globalAlpha = 1;
        }

        const x = i * fontSize;
        const y = drops[i] * fontSize;

        ctx.fillText(text, x, y);

        if (y > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i]++;
      }
      ctx.globalAlpha = 1; // Сброс
    };

    const interval = setInterval(draw, 40); // Чуть быстрее (25 FPS)

    return () => {
      clearInterval(interval);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0, // Самый нижний слой внутри grid
        pointerEvents: 'none',
        // Сделали в 2 раза прозрачнее (было 0.8, стало 0.4)
        opacity: 0.4,
      }}
    />
  );
};

export default MatrixRain;